export const SCREEN_LARGE = 1080;
